import { IAdpBatchInfo } from '@nkr/models/index';

interface IProps {
    batchInfo: IAdpBatchInfo,
    onDownloadManifest: (batch: IAdpBatchInfo) => void,
    onDownloadPdf: (batch: IAdpBatchInfo) => void,
    onDownloadCsv: (batch: IAdpBatchInfo) => void,
}

const BatchInfoRow = (props: IProps) => {
    const handleDownloadManifest = () => {
        props.onDownloadManifest(props.batchInfo);
    };

    const handleDownloadPdf = (e: any) => {
        props.onDownloadPdf(props.batchInfo);
    };

    const handleDownloadCsv = (e: any) => {
        props.onDownloadCsv(props.batchInfo);
    };

    const batchInfo = props.batchInfo;

    return (
        <tr>
            <td style={{ textAlign: 'center' }}>{batchInfo.id}</td>
            <td style={{ textAlign: 'center' }}>{batchInfo.createdDateTime}</td>
            <td style={{ textAlign: 'center' }}>{batchInfo.batchType}</td>
            <td style={{ textAlign: 'center' }}>{batchInfo.count}</td>
            <td style={{ textAlign: 'center' }}>
                <button className='btn btn-xs btn-primary' value={batchInfo.id} onClick={handleDownloadManifest}>Download Manifest</button>
            </td>
            <td style={{ textAlign: 'center' }}>
                <button className='btn btn-xs btn-primary' value={batchInfo.id} onClick={handleDownloadCsv}>Export CSV</button>
            </td>
            <td style={{ textAlign: 'center' }}>
                <button className='btn btn-xs btn-primary' value={batchInfo.id} onClick={handleDownloadPdf}>Download Pdf</button>
            </td>
        </tr>
    );
}

export default BatchInfoRow;